<template>
  <v-text-field
    outlined
    background-color="white"
    :value="link"
    :label="title"
    readonly
    hide-details
    dense
    color="performance"
    ref="link"
    class="embedded-btn"
  >
    <template v-slot:append="">
      <v-btn color="performance" @click="copy" class="rounded-l-0">
        Copy
      </v-btn>
      <v-tooltip
        top
        v-model="showCopied"
        :position-x="tooltipX"
        :position-y="tooltipY"
      >
        <span class="pa-2">Copied!</span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "CopyTextField",
  props: { link: { type: String }, title: { type: String } },
  data: () => ({
    showCopied: false,
    tooltipX: 0,
    tooltipY: 0
  }),
  methods: {
    copy(event) {
      this.tooltipX = event.clientX;
      this.tooltipY = event.clientY;

      let textToCopy = this.$refs.link.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");

      this.showCopied = true;

      setTimeout(() => {
        this.showCopied = false;
      }, 3000);
    }
  }
};
</script>
